module.exports = __webpack_public_path__ + "2e683b0c4009ae6cd7fbe0b948e49544.MP3";